import { Box } from '@mui/material';
import { GuestJourneyChurnCards } from 'api/reports-service/guest-journey-reports.types';
import KpiCard from '../kpi-card/kpi-card.component';

export type ChurnedSummaryCardsProps = {
  data?: GuestJourneyChurnCards;
  loading?: boolean;
};

// Card order is an FE decision — the BE response is keyed by metric name. The
// churn-threshold note now rides on the card itself (valueDescription /
// footnote), so there is no FE-supplied description.
const CARD_ORDER: (keyof GuestJourneyChurnCards)[] = [
  'churnThresholdDays',
  'membersWhoOrdered',
  'churnedMembers',
  'churnRate',
  'medianDaysFromLastOrder',
  'projectedAnnualRevenue',
];

const ChurnedSummaryCards = ({
  data,
  loading = false,
}: ChurnedSummaryCardsProps) => (
  <Box
    display="grid"
    gap={2}
    gridTemplateColumns={{
      xs: '1fr',
      sm: 'repeat(2, 1fr)',
      md: 'repeat(3, 1fr)',
      lg: 'repeat(3, 1fr)',
      xl: 'repeat(6, 1fr)',
    }}
    data-testid="Churned.SummaryCards"
  >
    {CARD_ORDER.map(id => (
      <KpiCard
        key={id}
        card={data?.[id]}
        loading={loading}
        data-testid={`Churned.SummaryCard.${id}`}
      />
    ))}
  </Box>
);

export default ChurnedSummaryCards;
